<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :stroke-width="stroke_width || '2'" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" fill="none" viewBox="0 0 26 26" style="enable-background:new 0 0 26 26;" xml:space="preserve" :class="class">
        <g>
            <path d="M18.7,21.4c.2,0,.4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4"/>
            <path d="M18.7,19.2v-3"/>
            <path d="M24.5,21.8c.3.5.2,1.2,0,1.7-.3.5-.9.8-1.5.8h-8.5c-.6,0-1.2-.3-1.5-.8-.3-.5-.4-1.2,0-1.7l4.2-8.5c.3-.6.9-1,1.6-1s1.3.4,1.6,1l4.2,8.5Z"/>
            <path d="M5.2,7.9h10.5"/>
            <path d="M5.2,12.4h7.5"/>
            <path d="M5.2,16.9h3.8"/>
            <path d="M9,21.4H3.7c-.8,0-1.5-.7-1.5-1.5V3.4c0-.8.7-1.5,1.5-1.5h10.6c.4,0,.8.2,1.1.4l2.9,2.9c.3.3.4.7.4,1.1v3.1"/>
        </g>
    </svg>
</template>

<script>
export default {
    props: ['class', 'stroke_width'],
}
</script>